<sc-flex class="structure-selection-field" [formGroup]="detailsFormGroup">
    <mat-form-field class="value-field">
        <mat-label>{{'stationName' | translate: ['tmc.transport.routing.routingPosition.stationName',
            translationService.language]}}</mat-label>
        <input matInput formControlName="value"/>
    </mat-form-field>
    <sc-content-spacer></sc-content-spacer>
    <button mat-icon-button (click)="doSelection()">
        <sc-icon iconClass="fa-sitemap"></sc-icon>
    </button>
</sc-flex>